import * as THREE from 'three';

export async function loadModel(filePath, modelGroup, loader = null, progressCallback = null) {
    return new Promise((resolve, reject) => {
        // Koristite prosleđeni loader ili kreirajte novi ako nije prosleđen
        const gltfLoader = loader || new GLTFLoader();

        gltfLoader.load(
            filePath,
            (gltf) => {
                const model = gltf.scene;

                // Centriranje modela po X i Y, postavljanje na 0 po Z
                const box = new THREE.Box3().setFromObject(model);
                const center = box.getCenter(new THREE.Vector3());
                model.position.set(-center.x, 0, -box.min.z);

                // Omogući senke
                model.traverse((child) => {
                    if (child.isMesh && child.material) {
                      child.material.transparent = true;
                      child.material.needsUpdate = true;
                    }
                });                  

                modelGroup.add(model);

                resolve(model);
            },
            (xhr) => {
                // Pozovite progress callback ako je prosleđen
                if (progressCallback && xhr.lengthComputable) {
                    progressCallback(xhr.loaded, xhr.total);
                }
                
                // Debug logging
                console.log(`Loading ${filePath}: ${(xhr.loaded / xhr.total * 100).toFixed(2)}%`);
            },
            (error) => {
                console.error("❌ Greška pri učitavanju modela:", error);
                reject(error);
            }
        );
    });
}